<template functional>
  <v-chip
    v-bind="data.attrs"
    label
    :dark="$options.methods.isDarkChip(props.propertyType)"
    small
    :class="[data.staticClass, data.class]"
    :color="$options.methods.getPropertyTypeColor(props.propertyType)"
    v-on="data.on"
  >
    {{ props.propertyType }}
  </v-chip>
</template>

<script lang="ts">
import Vue from 'vue';

import { getPropertyTypeColor } from '@/bundles/Property/helpers/colors/getPropertyTypeColor';
import { PropertyTypeEnum } from '@/bundles/Property/interfaces/PropertyType';

export default Vue.extend({
  name: 'PropertyTypeChip',

  props: {
    propertyType: {
      type: String,
      required: true
    },
  },

  methods: {
    getPropertyTypeColor,
    isDarkChip (propertyType: PropertyTypeEnum) {
      return propertyType !== PropertyTypeEnum.retail;
    }
  }
});
</script>
